import { render, staticRenderFns } from "./BusinessGroupItemForm.vue?vue&type=template&id=1eb9cd26"
import script from "./BusinessGroupItemForm.vue?vue&type=script&lang=js"
export * from "./BusinessGroupItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports